/****************************
* Navigation handler object *
****************************/

// import dependencies
import { TimelineLite } from 'gsap';

/**
* Main menu responsive handler
*
* @since 1.1.0 GSAP animations introduced
* @param {Object} jQuery
* @return {Object} init Initialization method
*/
function Navigation( $ ) {

	// Set up properties
	let isOpen = false,
		isMenuChanged = false,
		isToggleSubMenuAdded = false,
		resetTimeout,
		resetScroll,
		$menuToggle = $( '.js-menu-toggle' ),
		$hamburgerLines = $( '.js-hamburger-lines' ),
		$hdrLogo = $( '.hdr-logo' ),
		$menuContainer = $( '.js-menu-container' ),
		$menuItems = $( '.js-menu-item' ),
		$screen = $( 'html, body' ),
		tl = new TimelineLite( { paused: true } ),
		$menuItemsLinks = $( '.menu__menu-item a' ),
		$headerNavigation = $( '.header__navigation' ),
		$languageSwitcher = $( '.lang-item' ).children(),
		$menuItemWithChildren = $( '.menu-item-has-children' ),
		$menuLinkWithChildren = $( '.menu-item-has-children a' ),
		$childrenMenuContainer = $( '.menu-item-has-children .menu' ),

		$header = $( '.js-header' );
		const langBefore = window.getComputedStyle(
			document.querySelector('.lang-item'), ':before'
		).getPropertyValue('background-color');

	// define menu animations
	tl.to( $menuContainer, 0.2, { y: '0%', scale: 1, opacity: 1  } )
	  .staggerTo( $menuItems, 0.2, { opacity: 1 }, 0.05 );

    /**
    * Add/Remove children-menu class. Sub Menu toggle on small screen
    *
    * @since 1.0.0
    * @access private
    */
	function toggleSubMenu( e ) {

		e.preventDefault();

		if ( $childrenMenuContainer.hasClass( 'children-menu' ) ) {

			$childrenMenuContainer.removeClass( 'children-menu' );

		} else {

			$childrenMenuContainer.addClass( 'children-menu' );

		}
		$childrenMenuContainer.toggle('slow');

	}

	/**
	*  Add or remove class children-menu, depeands of screen width. On mobile menu should toggle, but not on desktop
	*
	* @since 1.0.0
	* @access private
	*/
	function addOrRemoveToggleSubMenu() {

		if ( $( window ).width()  > 1199 && isToggleSubMenuAdded ) {

			$menuItemWithChildren.off( 'click', toggleSubMenu );
			isToggleSubMenuAdded = false;

		} else if (  $( window ).width()  <= 1199 && !isToggleSubMenuAdded) {

			$menuItemWithChildren.on( 'click', toggleSubMenu );
			isToggleSubMenuAdded = true;

		}
	}

	/**
  	* Site header change style when user scroll
  	*
  	* @since 1.0.0
  	* @access private
  	*/
	function changedHeader() {

		$menuItemsLinks.addClass('change-color');
		$header.addClass('changed-header');
		$headerNavigation.addClass('header-height');
		$languageSwitcher.addClass('change-border-lagn-switcher');
		$hamburgerLines.addClass('is-scrolled');
		$('.lang-item').addClass('change-lang-switcher');

	}
	/**
  	*  Return to default header when user scroll to the top
  	*
  	* @since 1.0.0
  	* @access private
  	*/
	function defaultHeader() {

		$header.removeClass('changed-header');
		$headerNavigation.removeClass('header-height');
		$menuItemsLinks.removeClass('change-color');
		$languageSwitcher.removeClass('change-border-lagn-switcher');
		$hamburgerLines.removeClass('is-scrolled');
		$('.lang-item').removeClass('change-lang-switcher');


	}

	/**
	* Check screen width and change header depeands of user scroll height
	*
	* @since 1.0.0
	*/
	function checkScreenAndChangeSiteHeader() {

		let scrollHeight = $(window).scrollTop();

		if ( $( window ).width() > 1199 ) {

			if ( scrollHeight > 200  && !isMenuChanged ) {

 				changedHeader();
				isMenuChanged = true;

			} else if ( scrollHeight <= 200  && isMenuChanged ) {

				defaultHeader();
				isMenuChanged = false;
			}

		} else {

			if ( scrollHeight > 50  && !isMenuChanged ) {

				changedHeader();
				$hdrLogo.css('height', '60px');
				$hdrLogo.css('overflow', 'hidden');
				isMenuChanged = true;

			} else if ( scrollHeight <= 50  && isMenuChanged ) {

				defaultHeader();
				$hdrLogo.css('height', 'auto');
				isMenuChanged = false;
			}
		}

	}


	function onScroll() {

		clearTimeout( resetScroll );

		resetScroll = setTimeout( checkScreenAndChangeSiteHeader, 0 );

	}

	/**
	* openMenu() opens menu and handles animations
	*
	* @since 1.0.0
	* @access private
	*/
	function openMenu() {

		// start animation
		tl.play();

		// setup state properties
		isOpen = true;
		$hamburgerLines.addClass( 'is-open' );
		$menuContainer.css( 'display', 'block' );
		// prevent screen from scrolling
		$( 'body' ).css( 'overflow', 'hidden' );


	}

	/**
	* close menu and handle fade out animations
	*
	* @since 1.0.0
	* @access private
	*/
	function closeMenu() {

		// play reversed in reverse
		tl.reverse();
		// setup state properties
		$menuContainer.css( 'display', 'none' );
		$hamburgerLines.removeClass( 'is-open' );
		isOpen = false;
		$( 'body' ).css( 'overflow', 'auto' );

	}

	/**
	* reset the state if user resize window
	*
	* @since 1.0.0
	* @access private
	*/
	function reset() {

		if ( $( window ).width() > 1199 ) {

			// reset animation and state properties
			tl.pause( 0 );
			$menuContainer.removeAttr( 'style' );
			$menuItems.removeAttr( 'style' );
			$menuToggle.removeClass( 'is-open' );
			$hamburgerLines.removeClass( 'is-open' );
			// $screen.removeClass( 'no-scroll' );
			isOpen = false;


		}

		addOrRemoveToggleSubMenu();

	}

	/**
	* debounce calls for reset() method
	*
	* @since 1.0.0
	* @access private
	*/
	function onResize() {

		clearTimeout( resetTimeout );

		resetTimeout = setTimeout( reset, 300 );

	}

	/**
	* initialization method, set up event handlers
	*
	* @since 1.0.0
	* @access public
	*/
	function init() {

		// Attach event handler on hamburger button
		$menuToggle.on( 'click', ( e ) => {

		// If menu is open call openMenu() otherwise call closeMenu()
		if ( !isOpen ) {

			openMenu();

		} else {

			closeMenu();

		}

		});

		addOrRemoveToggleSubMenu();

		// Attach event handler for window resize
		$( window ).on( 'resize', ( e ) => {

			onResize();

		});
		$( document ).on('scroll', ( e ) => {

			onScroll();

		});


	}

	return {
		init
	}

}

export default Navigation;
